import Styled from 'styled-components';
import {respondTo} from '@/respondTo';
export const MainContainer = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 3.75rem 1.25rem 2.5rem;
    gap: 1.25rem;
    color: var(--on-primary-dark);
    background-color: var(--background-light);

    ${respondTo.desktop`
        flex-direction: row;
        justify-content: space-between;
        padding: 2.5rem;
    `}

    ${respondTo.desktop_xl`
        padding: 3.75rem;
    `}


`;

export const TextBox = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.25rem;
    width: 100%;
    text-align: center;
    padding: 1.25rem 0 2.5rem;

    h1 {
        color : var(--on-background-light);
    }

    p {
        color: var(--on-background-light);
    }

    ${respondTo.desktop`
        justify-content: flex-start;
        align-items: flex-start;
        text-align: left;
        gap: 2.5rem;

        h1 {
            padding-right: 13rem;
        }
        `}

    ${respondTo.desktop_xl`
        h1 {
            padding-right: 8rem;
        }
    `}
    `;


export const ImgBox= Styled.div`
    object-fit: cover;
    width: 350px;
    height: auto;
    position: relative;



    ${respondTo.tablet_landscape_s`
        width: 567px;
        height: auto;
    `}

    ${respondTo.desktop_xl`
        width: 792px;
         height: auto; 
    `}

`;

